// Hover preview for live cards: after a short hover delay the thumbnail
// swaps for a muted autoplay embed — parity with the legacy
// EmbeddedLiveBroadcast, minus its UA sniffing: hover-capable pointers
// only, via matchMedia('(hover: hover)'). Depends on the SOR-614
// Referrer-Policy fix (PR #97) or YouTube refuses to play the embed.
import React, { useEffect, useRef, useState } from 'react';
import gaEvents from '../events';

const HOVER_DELAY_MS = 400;

const canHover = () =>
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(hover: hover)').matches;

/** @param {{stream: import('./stream').Stream}} props */
const LiveThumbnail = ({ stream }) => {
  const [previewing, setPreviewing] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const base = stream.thumbnailUrl ? (
    <img src={stream.thumbnailUrl} alt="" />
  ) : (
    <span
      aria-hidden="true"
      className="block h-full w-full bg-browse-placeholder-grey"
    />
  );

  if (!stream.platformVideoId) return base;

  const start = () => {
    if (!canHover()) return;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      setPreviewing(true);
      gaEvents.broadcastsPreviewLiveBroadcast(
        stream.platformVideoId,
        stream.channelName,
        stream.title
      );
    }, HOVER_DELAY_MS);
  };
  const stop = () => {
    clearTimeout(timer.current);
    setPreviewing(false);
  };

  return (
    <span
      className="block h-full w-full"
      onMouseEnter={start}
      onMouseLeave={stop}
    >
      {previewing ? (
        // pointer-events-none: the card link stays the click target
        <iframe
          title={`Preview: ${stream.title}`}
          src={`https://www.youtube.com/embed/${stream.platformVideoId}?autoplay=1&mute=1&controls=0&playsinline=1`}
          allow="autoplay"
          className="pointer-events-none h-full w-full border-0"
        />
      ) : (
        base
      )}
    </span>
  );
};

export default LiveThumbnail;
